// import React from 'react';
// import { Col, Row, Nav } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import { version } from 'config';

// const navItems = [
//   { label: 'Home', path: '/' },
//   { label: 'WorkSpace', path: '/space' },
//   { label: 'About CDAP', path: '/about-cdap' },
//   { label: 'Demo', path: '/demo' },
//   { label: 'Feedback', path: 'https://forms.gle/d6QZEAmB4vu3PX2x7', external: true }
// ];

// const Footer = () => (
//   <>
//     <footer className="fixed-bottom bg-white w-100 border-top">

//       {/* Ribbon Row */}
//       <Row
//         className="py-2"
//         style={{
//           backgroundColor: '#182760',
//           color: 'white',
//           textAlign: 'center'
//         }}
//       >
//         <Col>
//           <div style={{ fontSize: '12px' }}>
//             {navItems.map((item, index) => (
//               <span key={index}>
//                 {item.external ? (
//                   <a
//                     href={item.path}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{ color: 'white', textDecoration: 'none' }}
//                   >
//                     {item.label}
//                   </a>
//                 ) : (
//                   <Link
//                     to={item.path}
//                     style={{ color: 'white', textDecoration: 'none' }}
//                   >
//                     {item.label}
//                   </Link>
//                 )}

//                 {/* Add separator except after last item */}
//                 {index < navItems.length - 1 && (
//                   <span style={{ padding: '0 8px' }}>|</span>
//                 )}
//               </span>
//             ))}
//           </div>
//         </Col>
//       </Row>

//       {/* Existing Footer Content */}
//       <Col className="justify-content-between align-items-center fs--1 py-3 mx-0">

//         <Col sm="auto" className="d-flex align-items-center gap-3">
//           <p className="mb-0 text-800">
//             {new Date().getFullYear()} &copy; <a href="#">CDAP</a>
//           </p>

//           {/* Contact Us */}
//           {/* <p className="mb-0 text-800">
//             <a
//               href="https://forms.gle/SSeUZUY4ddKXpBZx7"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               Contact Us
//             </a>
//           </p> */}

//           {/* Disclaimer - now same color as version */}
//           <p
//             className="mb-0 text-800"
//             style={{ fontSize: '11px', whiteSpace: 'nowrap' }}
//           >
//            <strong>Disclaimer:</strong>This platform is a prototype and is currently under active development. Features, data, and functionality may change, and certain components may operate in a limited or preliminary form.


//           </p>
//         </Col>

//         {/* <Col sm="auto">
//           <p className="mb-0 text-800">v{version}</p>
//         </Col> */}

//       </Col>

//     </footer>
//   </>
// );

// export default Footer;
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { version } from 'config';

const navItems = [
  // { label: 'Home', path: '/' },
  // { label: 'WorkSpace', path: '/space' },
  // { label: 'About CDAP', path: '/about-cdap' },
  // { label: 'Demo', path: '/demo' },
  { label: 'Contact Us', path: 'https://forms.gle/TXsfyYEASodF6dcS6', external: true },
  { label: 'Feedback', path: 'https://forms.gle/d6QZEAmB4vu3PX2x7', external: true }
];

const Footer = () => (
  <>
    <footer className="fixed-bottom bg-white w-100 border-top">

      {/* Top Navigation Ribbon */}
      <Row
        className="py-2"
        style={{
          backgroundColor: '#182760',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <Col>
          <div style={{ fontSize: '12px' }}>
            {navItems.map((item, index) => (
              <span key={index}>
                {item.external ? (
                  <a
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'white', textDecoration: 'none' }}
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    to={item.path}
                    style={{ color: 'white', textDecoration: 'none' }}
                  >
                    {item.label}
                  </Link>
                )}
                {index < navItems.length - 1 && (
                  <span style={{ padding: '0 8px' }}>|</span>
                )}
              </span>
            ))}
          </div>
        </Col>
      </Row>

      {/* Footer Main Content - now stacked responsively */}
      <Row className="py-3 text-center text-md-start mx-0"
           style={{ fontSize: '12px' }}
      >
        <Col xs={12} md="auto" className="mb-2 mb-md-0">
          <p className="mb-0 text-800">
            {new Date().getFullYear()} &copy; <a href="#">CDAP</a>
          </p>
        </Col>

        {/* Disclaimer — now fully wrapping and visible */}
        <Col xs={12} md="auto">
          <p
            className="mb-0 text-800"
            style={{
              fontSize: '11px',
              whiteSpace: 'normal',   // allow wrapping
              lineHeight: '1.3',
              padding: '0 10px'
            }}
          >
            <strong>Disclaimer:</strong> This platform is a prototype and is currently
            under active development. Features, data, and functionality may change, and
            certain components may operate in a limited or preliminary form.
          </p>
        </Col>
      </Row>

    </footer>
  </>
);

export default Footer;
